var ConnectionStatus;
(function (ConnectionStatus) {
    ConnectionStatus[ConnectionStatus["PENDING"] = 1] = "PENDING";
    ConnectionStatus[ConnectionStatus["CONNECTED"] = 2] = "CONNECTED";
    ConnectionStatus[ConnectionStatus["DISCONNECTED"] = 3] = "DISCONNECTED";
})(ConnectionStatus || (ConnectionStatus = {}));
export default ConnectionStatus;
